<template>
  <span v-if="canReview">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="openReviewDialog"
          data-cy="proof"
        >
          mdi-check-decagram
        </v-icon>
      </template>
      <span>{{ $t("riskAssessment.proof.reviewButton") }}</span>
    </v-tooltip>

    <v-dialog v-model="reviewDialog.open" max-width="540" persistent>
      <v-card>
        <v-card-title>{{
          $t("proofReview.dangerousGood.title")
        }}</v-card-title>
        <v-card-subtitle class="pb-0">
          {{ item.identifier }} {{ item.name }}
        </v-card-subtitle>
        <v-card-text class="pt-4">
          <v-radio-group v-model="mode" hide-details class="mt-0">
            <v-radio v-if="canProof" value="approve" color="primary">
              <template v-slot:label>
                <span>{{ $t("proofReview.dangerousGood.agree") }}</span>
              </template>
            </v-radio>
            <v-radio value="reject" color="error" class="mt-3">
              <template v-slot:label>
                <span>{{ $t("proofReview.dangerousGood.disagree") }}</span>
              </template>
            </v-radio>
          </v-radio-group>

          <v-textarea
            v-if="mode === 'reject'"
            v-model="rejectReason"
            :label="$t('riskAssessment.proof.rejectReason')"
            class="mt-4"
            outlined
            dense
            rows="3"
            auto-grow
            hide-details
            autofocus
          />
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer />
          <v-btn text @click="closeReview" :disabled="busy">
            {{ $t("general.cancel") }}
          </v-btn>
          <v-btn
            :color="mode === 'reject' ? 'error' : 'primary'"
            :disabled="!canConfirm"
            :loading="busy"
            @click="confirmReview"
          >
            {{ $t("general.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  props: ["item", "config"],
  data: () => ({
    reviewDialog: { open: false },
    mode: null,
    rejectReason: "",
    approving: false,
    rejecting: false,
  }),
  computed: {
    busy() {
      return this.approving || this.rejecting;
    },
    currentVersionData() {
      const versions = (this.item && this.item.versions) || [];
      if (!versions.length) return null;
      return (
        versions.find((v) => v.version === this.item.currentVersion) ||
        versions[versions.length - 1]
      );
    },
    canProof() {
      const uid = this.config && this.config.currentUserId;
      if (!uid) return false;

      const version = this.currentVersionData;
      if (!version || version.status !== "pending") return false;

      const stage = (version.stages || [])[version.currentStage || 0];
      if (!stage || stage.approvedAt) return false;

      return (stage.members || []).some((m) => String(m.user) === String(uid));
    },
    canReject() {
      const uid = this.config && this.config.currentUserId;
      if (!uid) return false;

      const version = this.currentVersionData;
      if (!version || version.status !== "pending") return false;

      return (version.stages || []).some((stage) =>
        (stage.members || []).some((m) => String(m.user) === String(uid))
      );
    },
    canReview() {
      return this.canProof || this.canReject;
    },
    canConfirm() {
      if (this.mode === "approve") return true;
      if (this.mode === "reject") return !!this.rejectReason.trim();
      return false;
    },
  },
  methods: {
    openReviewDialog() {
      this.rejectReason = "";
      this.mode = this.canProof ? null : "reject";
      this.reviewDialog.open = true;
    },
    closeReview() {
      this.reviewDialog.open = false;
      this.mode = null;
      this.rejectReason = "";
    },
    confirmReview() {
      if (this.mode === "approve") return this.approveItem();
      if (this.mode === "reject") return this.rejectItem();
    },
    async approveItem() {
      this.approving = true;
      try {
        await this.$store.dispatch("approveDangerousGood", {
          id: this.item._id || this.item.id,
        });
        this.closeReview();
        this.$emit("reloadData");
      } finally {
        this.approving = false;
      }
    },
    async rejectItem() {
      this.rejecting = true;
      try {
        await this.$store.dispatch("rejectDangerousGood", {
          id: this.item._id || this.item.id,
          reason: this.rejectReason.trim(),
        });
        this.closeReview();
        this.$emit("reloadData");
      } finally {
        this.rejecting = false;
      }
    },
  },
};
</script>
